import { allTeamMembersSortableByLastNameForSelect } from '../../../graphql/custom_queries';
import PropTypes from 'prop-types';
import { generateClient } from "aws-amplify/api";

const client = generateClient();

export const fetchAllTeamMembers = async (allsort) => {
  const allItems = [];
  let nextToken = null;
  let pageCount = 0;
  const MAX_PAGES = 20; // safety bound; ~2000 active members at limit 100

  try {
    do {
      const gqlParams = {
        allSort: allsort || 'all',
        filter: { isActive: { eq: true } },
        sortDirection: 'ASC',
        limit: 500,
        nextToken,
      };

      const response = await client.graphql({
        query: allTeamMembersSortableByLastNameForSelect,
        variables: gqlParams,
      });

      const page = response.data.allTeamMembersSortableByLastName;
      if (page?.items?.length) {
        allItems.push(...page.items);
      }
      nextToken = page?.nextToken ?? null;
      pageCount += 1;

      if (pageCount >= MAX_PAGES) {
        console.warn(`fetchAllTeamMembers: hit MAX_PAGES (${MAX_PAGES}) — possible runaway pagination`);
        break;
      }
    } while (nextToken);

    console.log(`🤡 fetchAllTeamMembers: ${allItems.length} items across ${pageCount} page(s)`);
    return allItems;
  } catch (err) {
    // AppSync returns partial data alongside field-level errors.
    // If we have items despite the error, merge what we got with what came before.
    if (err?.data?.allTeamMembersSortableByLastName?.items) {
      console.warn('fetchAllTeamMembers partial errors:', err.errors);
      allItems.push(...err.data.allTeamMembersSortableByLastName.items);
      return allItems;
    }
    console.error('fetchAllTeamMembers error:', err);
    return allItems.length ? allItems : [];
  }
};

fetchAllTeamMembers.propTypes = {
  allsort: PropTypes.string,
};